export default "__VITE_ASSET__Dlf4QlLN__"